import component from './';

/** @type {UICore.ComponentMeta} */
const AccordionComponentMeta = {
  id: 'w-accordion',
  name: '可折叠面板',
  icon: 'https://vfiles.gtimg.cn/wuji_dashboard/xy/rainbow/icon-accordion_1636361857996.png',
  category: '布局',
  component,
  fitData: () => null,
  slots: [{
    id: 'default',
    containerRef: 'content'
  }, {
    id: 'action',
    containerRef: 'actions'
  }],
  bindings: [{
    id: '是否展开',
    prop: 'expanded',
    event: 'change',
    main: true,
    required: false
  }, {
    id: '标题',
    prop: 'title',
    checkData: s => s.type === 'string'
  }],
  events: [{
    id: 'change',
    name: '展开或收起',
    arguments: [{
      type: 'boolean',
      description: '当前是否已经展开(布尔值)'
    }]
  }, {
    id: 'expand',
    name: '展开'
  }, {
    id: 'collapse',
    name: '收起'
  }],
  propsSchema: {
    type: 'object',
    fields: [{
      id: 'title',
      type: 'string',
      title: '标题',
      default: '未命名折叠面板'
    }, {
      id: 'expanded',
      type: 'boolean',
      title: '是否展开',
      default: true
    }, {
      id: 'isCompact',
      type: 'boolean',
      group: '样式',
      title: '紧凑'
    }]
  },
  designerQuickEdit: [{
    trigger: {
      dblclick: true,
      selected: {
        onlyInserting: true
      }
    },
    content: ['prop:title', 'prop:expanded']
  }],
  getActions({
    layout,
    replaceCompWith
  }) {
    return [{
      title: '转为卡片',
      icon: 'fa fa-list-alt',
      execute: () => {
        var _layout$props;
        return replaceCompWith({
          type: 'w-card',
          props: {
            title: ((_layout$props = layout.props) === null || _layout$props === void 0 ? void 0 : _layout$props.title) || ''
          },
          children: layout.children,
          slots: layout.slots
        });
      }
    }];
  }
};
export default AccordionComponentMeta;